/** CoStar.Api.ListingMarketplace.Listing.ViewModels.BuildingStarRating */
export var BuildingStarRating;
(function (BuildingStarRating) {
    BuildingStarRating[BuildingStarRating["OneStar"] = 1] = "OneStar";
    BuildingStarRating[BuildingStarRating["TwoStar"] = 2] = "TwoStar";
    BuildingStarRating[BuildingStarRating["ThreeStar"] = 3] = "ThreeStar";
    BuildingStarRating[BuildingStarRating["FourStar"] = 4] = "FourStar";
    BuildingStarRating[BuildingStarRating["FiveStar"] = 5] = "FiveStar";
})(BuildingStarRating || (BuildingStarRating = {}));
/** CoStar.Api.ListingMarketplace.Listing.ViewModels.ProductFeedbackStatus */
export var ProductFeedbackStatus;
(function (ProductFeedbackStatus) {
    ProductFeedbackStatus[ProductFeedbackStatus["New"] = 1] = "New";
    ProductFeedbackStatus[ProductFeedbackStatus["ReviewedByLoopNetProduct"] = 2] = "ReviewedByLoopNetProduct";
    ProductFeedbackStatus[ProductFeedbackStatus["SentToCustomerSupport"] = 3] = "SentToCustomerSupport";
    ProductFeedbackStatus[ProductFeedbackStatus["SentToResearch"] = 4] = "SentToResearch";
    ProductFeedbackStatus[ProductFeedbackStatus["SentToProduct_Other"] = 5] = "SentToProduct_Other";
    ProductFeedbackStatus[ProductFeedbackStatus["BugLogged"] = 6] = "BugLogged";
    ProductFeedbackStatus[ProductFeedbackStatus["Rejected"] = 7] = "Rejected";
})(ProductFeedbackStatus || (ProductFeedbackStatus = {}));
/** CoStar.Api.ListingMarketplace.Listing.ViewModels.ProductFeedbackSource */
export var ProductFeedbackSource;
(function (ProductFeedbackSource) {
    ProductFeedbackSource[ProductFeedbackSource["SearchResultsPage"] = 1] = "SearchResultsPage";
    ProductFeedbackSource[ProductFeedbackSource["ListingDetailPage"] = 2] = "ListingDetailPage";
    ProductFeedbackSource[ProductFeedbackSource["CompanyProfilePage"] = 3] = "CompanyProfilePage";
    ProductFeedbackSource[ProductFeedbackSource["HomePage"] = 4] = "HomePage";
})(ProductFeedbackSource || (ProductFeedbackSource = {}));
/** CoStar.Api.ListingMarketplace.Listing.ViewModels.ProductFeedbackType */
export var ProductFeedbackType;
(function (ProductFeedbackType) {
    ProductFeedbackType[ProductFeedbackType["New"] = 1] = "New";
    ProductFeedbackType[ProductFeedbackType["ExistingProductEnhancementRequest"] = 2] = "ExistingProductEnhancementRequest";
    ProductFeedbackType[ProductFeedbackType["NewFeatureRequest"] = 3] = "NewFeatureRequest";
    ProductFeedbackType[ProductFeedbackType["ListingManagerFeedback"] = 4] = "ListingManagerFeedback";
    ProductFeedbackType[ProductFeedbackType["CoStarProductFeedback"] = 5] = "CoStarProductFeedback";
    ProductFeedbackType[ProductFeedbackType["CustomerSupportRequest"] = 6] = "CustomerSupportRequest";
    ProductFeedbackType[ProductFeedbackType["BugReport"] = 7] = "BugReport";
    ProductFeedbackType[ProductFeedbackType["ResearchRequest"] = 8] = "ResearchRequest";
    ProductFeedbackType[ProductFeedbackType["InvalidSubmission"] = 9] = "InvalidSubmission";
    ProductFeedbackType[ProductFeedbackType["Other"] = 10] = "Other";
})(ProductFeedbackType || (ProductFeedbackType = {}));
/** CoStar.Api.ListingMarketplace.Listing.ViewModels.MarketingBrand */
export var MarketingBrand;
(function (MarketingBrand) {
    MarketingBrand[MarketingBrand["Loopnet"] = 6] = "Loopnet";
    MarketingBrand[MarketingBrand["CityFeet"] = 7] = "CityFeet";
    MarketingBrand[MarketingBrand["ShowCase"] = 8] = "ShowCase";
})(MarketingBrand || (MarketingBrand = {}));
/** CoStar.Api.ListingMarketplace.Listing.ViewModels.ProductFeedbackScoreRating */
export var ProductFeedbackScoreRating;
(function (ProductFeedbackScoreRating) {
    ProductFeedbackScoreRating[ProductFeedbackScoreRating["NoRating"] = 0] = "NoRating";
    ProductFeedbackScoreRating[ProductFeedbackScoreRating["OneStar"] = 1] = "OneStar";
    ProductFeedbackScoreRating[ProductFeedbackScoreRating["TwoStar"] = 2] = "TwoStar";
    ProductFeedbackScoreRating[ProductFeedbackScoreRating["ThreeStar"] = 3] = "ThreeStar";
    ProductFeedbackScoreRating[ProductFeedbackScoreRating["FourStar"] = 4] = "FourStar";
    ProductFeedbackScoreRating[ProductFeedbackScoreRating["FiveStar"] = 5] = "FiveStar";
})(ProductFeedbackScoreRating || (ProductFeedbackScoreRating = {}));
